import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    meta: {
      icon: 'mdi:chart-box',
      order: 100,
      title: '报表',
    },
    name: 'AdReports',
    path: '/reports',
    children: [
      // 行业报表
      {
        name: 'AdIndustryReport',
        path: '/industry-report',
        component: () => import('#/views/reports/industry-report/index.vue'),
        meta: {
          icon: 'mdi:chart-box',
          title: '行业报表',
          keepAlive: true,
        },
      },
      {
        name: 'AdCustomerFundChange',
        path: '/customer-fund-change',
        component: () =>
          import('#/views/reports/customer-fund-change/index.vue'),
        meta: {
          icon: 'mdi:chart-line',
          title: '客户资金变动',
          keepAlive: true,
        },
      },
      {
        name: 'AdOverallIncomeExpense',
        path: '/overall-income-expense',
        component: () =>
          import('#/views/reports/overall-income-expense/index.vue'),
        meta: {
          icon: 'mdi:chart-timeline-variant',
          title: '整体收支监控',
          keepAlive: true,
        },
      },
      {
        name: 'AdRechargeDistribution',
        path: '/recharge-distribution',
        component: () =>
          import('#/views/reports/recharge-distribution/index.vue'),
        meta: {
          icon: 'mdi:chart-bar-stacked',
          title: '充值分布',
          keepAlive: true,
        },
      },

      {
        name: 'AdProfitDistribution',
        path: '/profit-distribution',
        component: () =>
          import('#/views/reports/profit-distribution/index.vue'),
        meta: {
          icon: 'mdi:chart-line-variant',
          title: '预计利润分布',
          keepAlive: true,
        },
      },
      {
        name: 'AdConsumptionDistribution',
        path: '/consumption-distribution',
        component: () =>
          import('#/views/reports/consumption-distribution/index.vue'),
        meta: {
          icon: 'mdi:chart-timeline-variant',
          title: '消耗分布',
          keepAlive: true,
        },
      },
      {
        name: 'AdCustomerReconciliationDaily',
        path: '/customer-reconciliation-daily',
        component: () =>
          import('#/views/reports/customer-reconciliation-daily/index.vue'),
        meta: {
          icon: 'mdi:file-document-outline',
          pageKey: 'AdCustomerReconciliationDaily',
          title: '客户对账日报',
          keepAlive: true,
        },
      },
      {
        name: 'AdWeekReport',
        path: '/week-report',
        component: () => import('#/views/reports/week-report/index.vue'),
        meta: {
          icon: 'mdi:calendar-week',
          pageKey: 'AdWeekReport',
          title: '广告周数据',
          keepAlive: true,
        },
      },
      {
        name: 'AdItBiweeklyReport',
        path: '/it-biweekly-report',
        component: () => import('#/views/reports/it-biweekly-report/index.vue'),
        meta: {
          icon: 'mdi:chart-timeline-variant-shimmer',
          title: 'IT双周会报表',
          keepAlive: true,
        },
      },
      {
        name: 'AdCustomerPerformance',
        path: '/ad-customer-performance',
        component: () =>
          import('#/views/reports/ad-customer-performance/index.vue'),
        meta: {
          icon: 'mdi:file-chart-outline',
          pageKey: 'AdCustomerPerformance',
          title: '广告客户表现',
          keepAlive: true,
        },
      },
      {
        name: 'AdBindCardAccount',
        path: '/bind-card-account',
        component: () => import('#/views/reports/bind-card-account/index.vue'),
        meta: {
          icon: 'mdi:card-account-details-outline',
          pageKey: 'AdBindCardAccount',
          title: '绑卡户管理',
          keepAlive: true,
        },
      },
      {
        name: 'AdCustLifecycle',
        path: '/customer-lifecycle',
        component: () => import('#/views/reports/customer-lifecycle/index.vue'),
        meta: {
          icon: 'mdi:timeline-text-outline',
          title: '客户生命周期',
          keepAlive: true,
        },
      },
      {
        name: 'AdAcctTxnSummary',
        path: '/acct-txn-summary',
        component: () => import('#/views/reports/acct-txn-summary/index.vue'),
        meta: {
          icon: 'mdi:file-table-outline',
          title: '综合充值清零减款',
          keepAlive: true,
        },
      },
      {
        name: 'AdNonApiSpend',
        path: '/non-api-spend',
        component: () => import('#/views/reports/non-api-spend/index.vue'),
        meta: {
          icon: 'mdi:database-alert-outline',
          title: '非接口方式获取消耗',
          keepAlive: true,
        },
      },
      {
        name: 'AdDailyReport',
        path: '/ad-daily-report',
        component: () => import('#/views/reports/ad-daily-report/index.vue'),
        meta: {
          icon: 'mdi:view-dashboard-outline',
          title: '广告日报',
          keepAlive: true,
        },
      },
    ],
  },
]

export default routes
